
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inclusive",
      function () {
        return require("private-next-pages/inclusive/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inclusive"])
      });
    }
  